import { Modal, Button } from 'react-bootstrap';
import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch,shallowEqual } from 'react-redux';

function Loading(props) {
    let show  = useSelector((state) => { return state.showLoading }); 
    return (
        <>
            <Modal show={show} >
                <Modal.Body>Por favor aguarde...</Modal.Body>
            </Modal>
        </>
    );
}

export default Loading;
